<template>
	<div class='vb-damages'>
		<span class='title'>Повреждения породы</span>
		<button @click='enableAddMode'>Добавить повреждение</button>
		<div class='add-block-outer' v-if='addMode'>
			<AddBlock :current-species='currentSpecies' @close='disableAddMode'/>
		</div>

		<template v-if='!currentSpecies.damages.length'>
			<div>
				<span>Повреждений нет</span>
			</div>
		</template>
		<template v-else>
			<table class='table-def'>
				<thead>
					<tr>
						<th>Категория состояния</th>
						<th>Причина</th>
						<th>Признак</th>
						<th>Доля от запаса породы, %</th>
						<th>Рубка</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for='damage in currentSpecies.damages' :key="damage.id">
						<td>{{ damage.state_cat }}</td>
						<td>{{ damage.reason }}</td>
						<td>{{ damage.symptom }}</td>
						<template v-if='isDamageEdited(damage)'>
							<td><input type='number' v-model='editedProcValue' style='text-align: center;'></td>
						</template>
						<template v-else>
							<td>{{ damage.symptom_proc }}</td>
						</template>
						
						<td><i class='fa fa-check' v-if='damage.is_felling'></i></td>
						<td v-if='isDamageEdited(damage)'>
							<button @click='saveEdit(damage)' class='p-mr-1'><fa-icon icon='check'/></button>
							<button @click='cancelEdit'><fa-icon icon='times'/></button>
						</td>
						<td v-else>
							<button @click='startEdit(damage)' class='p-mr-1'><fa-icon icon='edit'/></button>
							<button @click='remove(damage)'><fa-icon icon='trash'/></button>
						</td>
					</tr>
				</tbody>
			</table>
		</template>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import AddBlock from './Recount__bvSheetDamagesAdd';

	export default {
		name: 'RecountVbSheetDamages',
		components: {
			AddBlock
		},
		props: {
			currentSpecies: {
				type: Object,
				default: null
			},
		},
		data: () => ({
			addMode: false,
			editedDamage: null,
			editedProcValue: null,
		}),
		computed: {

			...mapState('selectedLpo/recount', {
				vbList: state => state['vbList'],
			})
		},

		methods: {
			enableAddMode() {
				this.addMode = true;
			},
			disableAddMode() {
				this.addMode = false;
			},

			isDamageEdited(damage) {
				return damage?.id === this.editedDamage?.id;
			},	

			startEdit(damage) {
				this.editedDamage = damage;
				this.editedProcValue = damage?.symptom_proc;
			},

			saveEdit(damage) {
				if (this.editedProcValue === null || this.editedProcValue === '') {
					this.$toast.add({severity: 'warn', detail: 'Необходимо указать значение', life: 10000});
					return;
				}

				if (+this.editedProcValue < 0) {
					this.$toast.add({severity: 'warn', detail: 'Некорректное значение (отрицательное число)', life: 10000});
					return;
				}
				let finded_state_cat = this.vbList.map(e => e.state_cats).flat().find(state_cat => {
					return state_cat.id === damage.parent_id;
				});

				if (!finded_state_cat) {
					this.$toast.add({severity: 'warn', detail: 'Ошибка! не найдена категория', life: 10000});
					return;
				}

				if (+this.editedProcValue > +finded_state_cat.trees_proc) {
					this.$toast.add({severity: 'warn', detail: 'Некорректное значение (Доля повреждения превышает долю деревьев в категории)', life: 10000});
					return;
				}

				this.editVbDamageProc({ damage, newProc: this.editedProcValue }).then(res => {
					return this.updateVbList();
				}).finally(() => {
					this.cancelEdit();
				});
			},

			cancelEdit() {
				this.editedDamage = null;
				this.editedProcValue = null;
			},

			remove(damage) {
				this.removeVbDamage(damage).then(res => {
					this.updateVbList();
				});
			},

			...mapActions('selectedLpo/recount', [
				'removeVbDamage',
				'updateVbList',
				'editVbDamageProc',
			]),
		},

	};
</script>

<style scoped src='@/style/table.css'></style>

<style scoped>
	.vb-damages .title {
		font-size: 1rem;
		display: inline-block;
		margin-top: 16px;
		margin-bottom: 14px;
		margin-right: 10px;
		font-weight: bold;
	}
</style>